export default __webpack_public_path__ + "static/media/image-banner-w@2x.f7f28e30.webp";